import { render, staticRenderFns } from "./FollowedIcon.vue?vue&type=template&id=5857268a&scoped=true"
import script from "./FollowedIcon.vue?vue&type=script&lang=js"
export * from "./FollowedIcon.vue?vue&type=script&lang=js"
import style0 from "./FollowedIcon.vue?vue&type=style&index=0&id=5857268a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5857268a",
  null
  
)

export default component.exports